<template>
  <v-app :dark="dark">
    <not-auth-toolbar :show-login="isGetToken"></not-auth-toolbar>
    <v-content>
      <v-slide-y-transition mode="out-in">
        <v-container justify-center>
          <v-layout class="pt-5" fill-height justify-center>
            <v-slide-y-transition group hide-on-leave>
              <v-card class="elevation-4" key="account" max-width="500px" v-if="loginType === 'account'">
                <v-card-title>
                  <span class="headline pl-2">校友认证</span>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text class="py-0">
                  <v-container class="pb-0 pt-2">
                    <v-form ref="accountForm">
                      <v-layout row wrap>
                        <v-flex xs12 class="py-1">
                          <v-text-field
                            :rules="$rules.phone11()"
                            label="联系电话"
                            placeholder="请输入联系电话"
                            prepend-icon="mdi-phone"
                            v-model="accountForm.phone"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12>
                          <v-text-field
                            class="pb-1"
                            single-line
                            label="验证码"
                            placeholder="请输入验证码"
                            prepend-icon="$vuetify.icons.code"
                            v-model="verifyObj.verifyCode"
                            :disabled="disabledFlag===true"
                            :error-messages="(disabledFlag===true)?'':verifyObj.errorMessage"
                          ></v-text-field>
                        </v-flex>
                        <v-btn flat color="primary" @click="getTmpToken();verifyObj.getFlag=true" :disabled="disabledFlag===true" v-if="verifyObj.expire<=0">
                          <span v-if="!verifyObj.getFlag">获取短信验证码</span>
                          <span v-else>重新获取</span>
                        </v-btn>
                        <span v-else style="font-size: 16px">{{verifyObj.expire}}s</span>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loginLoading" @click="wxBind" color="primary" flat large :disabled="disabledFlag">认证</v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-4" key="portal" max-width="500px" v-if="loginType ==='portal'">
                <v-card-title>
                  <span class="headline pl-2">电子科技大学统一身份认证</span>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text class="py-0">
                  <v-container class="pb-0 pt-2">
                    <v-form ref="portalForm">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[ v=> !!v || '请输入学号或工号']"
                            @keyup.enter="$refs.portalPassword.focus()"
                            label="学号/工号"
                            placeholder="请输入学号/工号"
                            prepend-icon="mdi-account-card-details"
                            v-model="accountForm.loginId"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="py-1" xs12>
                          <v-text-field
                            :rules="[ v=> !!v || '请输入密码']"
                            @keyup.enter="login()"
                            label="密码"
                            placeholder="请输入密码"
                            prepend-icon="mdi-lock"
                            ref="portalPassword"
                            type="password"
                            v-model="accountForm.password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="$rules.phone11()"
                            label="联系电话"
                            placeholder="请输入联系电话"
                            prepend-icon="mdi-phone"
                            v-model="accountForm.phone"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12>
                          <v-text-field
                            class="pb-1"
                            single-line
                            label="验证码"
                            placeholder="请输入验证码"
                            prepend-icon="$vuetify.icons.code"
                            v-model="verifyObj.verifyCode"
                            :disabled="disabledFlag===true"
                            :error-messages="(disabledFlag===true)?'':verifyObj.errorMessage"
                          ></v-text-field>
                        </v-flex>
                        <v-btn flat color="primary" @click="getTmpToken();verifyObj.getFlag=true" :disabled="disabledFlag===true" v-if="verifyObj.expire<=0">
                          <span v-if="!verifyObj.getFlag">获取短信验证码</span>
                          <span v-else>重新获取</span>
                        </v-btn>
                        <span v-else style="font-size: 16px">{{verifyObj.expire}}s</span>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loginLoading" @click="wxBind" color="primary" flat large :disabled="disabledFlag">认证</v-btn>
                </v-card-actions>
              </v-card>
            </v-slide-y-transition>
          </v-layout>
          <v-layout class="pt-4" justify-center>
            <v-btn :disabled="loginLoading"
                   @click="loginType = loginType === 'account'?'portal':'account'"
                   color="primary" flat>
              <v-icon v-if="loginType === 'account'" small class="mr-2">$vuetify.icons.loginId</v-icon>
              <v-icon v-if="loginType === 'portal'" small class="mr-2">$vuetify.icons.person</v-icon>
              {{typeMap[loginType]}}认证
            </v-btn>
          </v-layout>
        </v-container>
      </v-slide-y-transition>
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import AppFooter from '../APP/Footer/appFooter'
import NotAuthToolbar from '../APP/Toolbar/notAuthToolbar'
import VerifyForm from '../Login/verifyForm'
export default {
  name: 'wxLogin',
  components: {VerifyForm, NotAuthToolbar, AppFooter},
  data: () => ({
    jsCode: '',
    verifyKey: '',
    needVerify: false,
    loginType: 'portal',
    error: true,
    errorMessage: '',
    loginLoading: false,
    loading: false,
    portalForm: {
      loginId: '',
      password: '',
    },
    accountForm: {
      loginId: '',
      password: '',
      phone: ''
    },
    verifyObj: {
      show: false,
      getFlag: false,
      expire: 0,
      key: '',
      verifyCode: '',
      verifyKey: '',
      errorMsg: '',
      checkStatus: false
    },
    disabledFlag: false,
    typeMap : {
      account:'校友',
      visitor:'访客',
      portal:'portal'
    }
  }),
  computed: {
    smallScreen () {
      return this.$vuetify.breakpoint.smAndDown
    },
    isLogin () {
      return this.$store.getters['login/isLogin']
    },
    isGetToken () {
      return this.$store.getters['login/isGetToken']
    },
    dark: {
      get () {
        return this.$store.getters['L/dark']
      },
      set (val) {
        this.$store.dispatch('L/setDark', val)
      }

    }
  },
  methods: {
    async wxBind () {
      this.loginLoading = true
      let checkRes = await this.checkCode()
      if (checkRes) {
        let param = {}
        if (this.loginType === 'portal') {
          param = {
            'username': this.accountForm.loginId,
            'password': this.accountForm.password,
            'verifyKey': this.verifyObj.verifyKey
          }
        }
        else {
          param = {
            'verifyKey': this.verifyObj.verifyKey
          }
        }
        let res = await this.$store.dispatch('wx/bindUser', {param: param, jsCode: this.jsCode, phone: this.accountForm.phone})
        if (res.data.status === 1) {
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=https://smaco2.uestc.edu.cn/wx/qrcode&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
        }
        else {
          this.disabledFlag = false
          this.verifyObj.expire = -1
          this.verifyObj.errorMsg = res.data.msg + ',请重新获取'
          this.$L.alert('error', {message: res.data.msg})
        }
      }
      this.loginLoading = false
    },
/*    async autoLogin () {
      let res = await this.$store.dispatch('wx/autoLogin', this.jsCode)
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '自动登录成功'})
        this.$router.push({
          path: '/wx/qrcode',
          query: {
            jsCode: this.jsCode
          }})
      }
      else if (res.data.status === 0) {
        this.$L.alert('error', {message: '尚未绑定，请先完成相关认证'})
      }
    },*/
    async getTmpToken () {
      if ((this.loginType === 'account' && !this.$refs.accountForm.validate())) {
        alert('表单存在不合法数据，请先完善表单')
        return
      }
      else if ((this.loginType === 'portal' && !this.$refs.portalForm.validate())) {
        alert('表单存在不合法数据，请先完善表单')
        return
      }
      this.verifyObjReset()
      let res = await this.$store.dispatch('letterReservation/selfSign_getTmpToken')
      if (res.data.status === 1) {
        this.verifyObj.expire = 60
        this.verifyObj.key = res.data.data.key
        this.sendVertifyMessage()
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async sendVertifyMessage () {
      let res = await this.$store.dispatch('letterReservation/selfSign_getVerifyMsg', {key: this.verifyObj.key, phone: this.accountForm.phone})
      if (res.data.status === 1) {
        this.verifyObj.verifyKey = res.data.data.verifyKey
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async checkCode () {
      this.disabledFlag = true
      let config = {
        'verifyKey': this.verifyObj.verifyKey,
        'realMsg': this.verifyObj.verifyCode
      }
      let res = await this.$store.dispatch('letterReservation/selfSign_checkVerify', config)
      if (res.data.status === 1) {
        /* this.verifyObjReset() */
        return true
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
        this.disabledFlag = false
        this.verifyObj.expire = -1
        this.verifyObj.errorMsg = res.data.msg + ',请重新获取'
        return false
      }
    },
    verifyObjReset () {
      this.verifyObj.show = false
      this.verifyObj.getFlag = false
      this.verifyObj.verifyCode = ''
      this.verifyObj.errorMsg = ''
      this.verifyObj.expire = 0
    },
  },
  created () {
    this.jsCode = this.$route.query.code
    // alert(this.jsCode)
    //this.autoLogin()
  },
  watch: {
    'verifyObj.expire' (val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1
          }, 1000)
        }
        else {
          setTimeout(() => {
            this.verifyObj.expire -= 1
          }, 1000)
        }
      }
      else if (val === 0) {
        this.verifyObj.errorMessage = '验证码已过期，请重新获取'
      }
      else {}
    },
    'verifyObj.verifyCode' () {
      // console.log('change')
      this.verifyObj.errorMessage = ''
    }
  }
  // beforeRouteEnter (to, from, next) {
  //   console.log(to.path, from.path, to, from)
  //   next()
  // }
}
</script>

<style scoped>

</style>
